import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroSection from "@/components/HeroSection";
import MarqueeSection from "@/components/MarqueeSection";
import DestaquesSection from "@/components/DestaquesSection";
import SobreSection from "@/components/SobreSection";
import ServicesBento from "@/components/ServicesBento";
import ComoPedir from "@/components/ComoPedir";
import Reveal from "@/components/Reveal";

const CtaBand = () => (
    <section className="bg-forge-yellow text-forge-ink" data-testid="home-cta-band">
        <div className="zf-container flex flex-col items-start justify-between gap-8 py-16 md:flex-row md:items-center md:py-20">
            <Reveal>
                <p className="font-mono text-xs uppercase tracking-[0.3em]">Ziggs Forge</p>
                <h2 className="mt-3 font-display text-3xl font-black uppercase leading-tight md:text-5xl">
                    Pronto para forjar
                    <br className="hidden md:block" /> sua ideia?
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <Link
                    to="/contato"
                    data-testid="home-cta-contact"
                    className="group inline-flex items-center gap-3 bg-forge-ink px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-forge-yellow transition-transform duration-300 hover:-translate-y-0.5 md:text-sm"
                >
                    Falar com a Ziggs
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
            </Reveal>
        </div>
    </section>
);

const Home = () => (
    <>
        <HeroSection />
        <MarqueeSection />
        <DestaquesSection />
        <SobreSection />
        <ServicesBento />
        <ComoPedir />
        <CtaBand />
    </>
);

export default Home;
